import { type Cell, flexRender } from "@tanstack/react-table";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type MobileTableHeaderCellProps<TData> = {
  cell: Cell<TData, unknown>;
  rowId: string;
  cellClassName?: string;
};

export function MobileTableHeaderCell<TData>({
  cell,
  rowId,
  cellClassName,
}: MobileTableHeaderCellProps<TData>) {
  return (
    <div className="flex items-center gap-2 max-w-full truncate">
      <div
        className={cnTwMerge(
          "flex body-base-regular text-wrap",
          cell.column.columnDef.isMobileSelector ? "shrink-0" : "truncate",
          cellClassName,
        )}
        data-testid={`mobile-header-cell-${rowId}-${cell.column.id}`}
      >
        {flexRender(cell.column.columnDef.cell, cell.getContext())}
      </div>
    </div>
  );
}
